import React from 'react';
import SlideLine from '../ui/slideLine';

import * as style from './timelineIntro.module.scss';
import * as timelineStyle from "./timeline.module.scss";

const TimelineIntro = props => (
  <div
    className={`typeFonts1 ${timelineStyle.timelineBlock} ${
      style.timelineIntro
    } ${props.isIE ? style.isIE : ''}`}
  >
    <div className="row row--center-horz">
      <div
        className={`${
          style.timelineIntroText
        } col-xs-12 col-md-11 col-lg-8 push-lg-1`}
      >
        <div className={style.timelineIntroSpace}>
          {props.label && <p className={style.timelineLabel}>{props.label}</p>}
          <h1>{props.title}</h1>
          <SlideLine />
          {props.subtitle && <p className={style.subtitle}>{props.subtitle}</p>}
        </div>
        {props.introText && (
          <p className={`intro ${style.introTextParagraph}`}>
            {props.introText.text}
          </p>
        )}
      </div>
    </div>
  </div>
);

export default TimelineIntro;
